var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isOverlayShown
    ? _c(
        "div",
        { attrs: { "data-overlay": "" }, on: { click: _vm.onOverlayClicked } },
        [_vm._t("popup", null, { isOverlayShown: _vm.isOverlayShown })],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }